import React, { createContext } from 'react';
import PropTypes from 'prop-types';

export const BranchContext = createContext();

export class BranchProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedBranch: null,
    };
  }

  selectBranch = (branch) => {
    this.setState({ selectedBranch: branch });
  };

  getContextValue = () => {
    return {
      ...this.state,
      selectBranch: this.selectBranch,
    };
  };

  render() {
    const { children } = this.props;

    return (
      <BranchContext.Provider value={this.getContextValue()}>{children}</BranchContext.Provider>
    );
  }
}

BranchProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
